export default __webpack_public_path__ + "static/media/bg3.6c477b8f.jpg";